import ConfettiGenerator from "confetti-js";
import { useEffect, useState } from "react";

// https://stackoverflow.com/a/5624139/786644
const hexToRgb = (hex: string) => {
	// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	// eslint-disable-next-line unicorn/better-regex
	const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	hex = hex.replace(shorthandRegex, (m, r, g, b) => {
		return r + r + g + g + b + b;
	});

	// eslint-disable-next-line unicorn/better-regex
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? [
				Number.parseInt(result[1]!, 16),
				Number.parseInt(result[2]!, 16),
				Number.parseInt(result[3]!, 16),
			]
		: undefined;
};

export const Confetti = ({
	colors,
	canvasId = "confetti",
	interactive = true,
}: {
	colors?: [string, string, string];
	// Canvas element id (also the confetti-js target). Defaults to "confetti"
	// so the LiveGame usage keeps its existing full-screen `#confetti` styling
	// and behavior unchanged.
	canvasId?: string;
	// When false, the canvas ignores taps (pointer-events handled by CSS) and
	// does not self-dismiss on click — used inside the moment overlay so the CTA
	// stays tappable.
	interactive?: boolean;
}) => {
	const [clicked, setClicked] = useState(false);

	useEffect(() => {
		const confettiSettings = {
			target: canvasId,
			colors: colors ? colors.map(hexToRgb) : undefined,
			rotate: true,
			size: 2,
		};
		const confetti = new ConfettiGenerator(confettiSettings);
		confetti.render();

		return () => confetti.clear();
	}, [colors, canvasId]);

	if (clicked) {
		return null;
	}

	return (
		<canvas
			id={canvasId}
			onClick={
				interactive
					? () => {
							setClicked(true);
						}
					: undefined
			}
		></canvas>
	);
};
